import React from 'react';
import {config} from '../../../../config';
import Icon from "../../../components/Icon";
import Title from "../../../components/Title";
import {Button} from "../../../components/Button";
import moment from "moment";
import Followers from "./Followers";
import Following from "./Following";
import {trancheAge} from "../../../../libs/helper";
import createLink from "../../../../libs/createLink";
import FriendsListSidebar from "../../../components/Friends/FriendsListSidebar";

class ProfileDescription extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            moreAboutme: false
        }
    }

    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.state !== nextState){
            return true;
        }
        if(this.props.userInitialized !== nextProps.userInitialized){
            return true;
        }
        if(this.props.userFriendsTotal !== nextProps.userFriendsTotal){
            return true;
        }
        if(this.props.location.pathname !== nextProps.location.pathname){
            return true;
        }
        return false;
    }

    render() {
        let userContent = this.props.user.profile.description ? this.props.user.profile.description : "";
        return (
            <div className={`card profil-description ${this.state.moreAboutme ? 'active' : ''}`}>
                <Title heading={"heading-2"} display={"display-5"}>
                    Tout sur moi
                    <span className="see-more"
                          onClick={() => this.setState({moreAboutme: !this.state.moreAboutme})}>{this.state.moreAboutme ? 'Réduire' : 'En voir plus'}
                        <Icon type="chevron-right"/></span>
                </Title>
                {this.props.isMe && (
                    <Button className={"full my-8"}
                            size={"small"}
                            btnStyle={"edit"}
                            icon={"pencil"}
                            to={createLink("userMeSettings")}
                            content={"Editer"}/>
                )}
                <div className="presentation">
                    {(userContent.length >= 1) &&
                        <p>
                            {userContent}
                        </p>
                    }
                </div>
                <div className="row full justify-center">
                    <Followers user={this.props.user}/>
                    <Following user={this.props.user}/>
                </div>
                <div className={"user-main-informations"}>
                    <div className="user-informations">
                        <div className="user-informations-title">Sexe</div>
                        <div className="user-informations-data">
                            <Icon type={config.genderClass[this.props.user.profile.gender]}/>
                            {config.genderList[this.props.user.profile.gender]}
                        </div>
                    </div>
                    <div className={"row"}>
                        {this.props.user.profile.informations.map((informations, index) => {
                            let currentAge = informations.birthday ? moment().diff(informations.birthday, 'years') : '';
                            let tranche = trancheAge(currentAge);
                            return informations.birthday !== null && informations.orientation !== 0 && currentAge >=18 && (
                                <div className={"column multiple-user-informations"} key={index}>
                                    {informations.birthday !== null && (
                                        <div className="user-informations">
                                            <div className="user-informations-title" />
                                            <div className="user-informations-data">
                                                {tranche}
                                            </div>
                                        </div>
                                    )}
                                    {informations.orientation !== 0 &&(
                                        <div className="user-informations">
                                            <div className="user-informations-title" />
                                            <div className="user-informations-data">
                                                {config.genderOrientation[informations.orientation]}
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )
                        })
                        }
                    </div>

                    <div className="user-informations">
                        <div className="user-informations-title">Date d'inscription</div>
                        <div className="user-informations-data">
                            {moment(this.props.user.createdAt).format("DD/MM/YYYY")}
                        </div>
                    </div>
                    <div className="user-informations">
                        <div className="user-informations-title">Dernière activité</div>
                        <div className="user-informations-data">
                            {moment(this.props.user.lastActivity).format("DD/MM/YYYY à HH:mm")}
                        </div>
                    </div>
                    <div className="user-informations">
                        <div className="user-informations-title">Visites sur le profil</div>
                        <div className="user-informations-data">
                            {this.props.user.count.view.toString().replace(/\B(?=(\d{3})+(?!\d))/g, " ")}
                        </div>
                    </div>
                </div>
                {(this.props.isMe || this.props.user.setting.displayFriends) && !RegExp('/amis/*').test(this.props.location.pathname) && (
                    <div className={"profile-side-friends"}>
                        <FriendsListSidebar match={this.props.match}
                                            user={this.props.user}
                                            displayTitle={true}
                                            isMe={this.props.isMe}/>
                    </div>
                )}

            </div>
        )
    }
}

export default ProfileDescription;